import { Box, Stack, styled } from "@tm/components"

export const StyledStack = styled(Stack)({
    flexWrap: "wrap",
})
StyledStack.defaultProps = { direction: "row", spacing: 0 }

export const StyledBox = styled(Box)({})
StyledBox.defaultProps = { pb: 1, mr: 2 }
